// DS1.7
import React from 'react';
import c from 'classnames';
import s from './DotIndicator.scss';
const DotIndicator = ({ color = 'green', className })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], s[`color-${color}`], className)
    });
};
DotIndicator.displayName = 'DotIndicator';
export default DotIndicator;

//# sourceMappingURL=DotIndicator.js.map